// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"SpendDropDownHeader_dropdown__3er8C"};